module.exports = __webpack_public_path__ + "static/agelider_logo-5eef7e1733fe1620ba1649e21b65c4ec.png";